<template>
  <ClientsTable :clients="layout === 'choosePerson' ? projectClients : clients" :layout="layout"></ClientsTable>
</template>


<script type="text/javascript">
  import {mapActions, mapState} from "vuex";
  import eventBus from "../../../../event-bus/eventBus";

  export default {
    name: "ClientsTableSelect",
    components: {
      ClientsTable: () => import('../../../Clients/components/ClientsTable/ClientsTable')
    },
    props: {
      isOfferForm: Boolean,
      selectedId: Array,
      deletedId: Array,
      layout: String,
      projectClients: Array,
    },
    methods: {
      ...mapActions("getClients", ["getClients"]),
      filterSelectClients: function() {
        if(this.selectedId !== undefined) {
            this.clients.filter((item) => {
              for(let i = 0,  l = this.selectedId.length;i < l; i++) {
                if(this.selectedId[i]["id"] === item.id && this.deletedId.includes(item.id) === false) {
                  item.disabled = true;
                  break;
                } else {
                  item.disabled = false;
                }
              }
            if(this.selectedId.length === 0) {
              item.disabled = false;
            }});
        }
      }
    },
    computed: {
      ...mapState("getClients", {
        clients: state => state.dataReceive
      }),
    },
    mounted() {
      eventBus.$on("getClientsSuccess", () => {
        this.filterSelectClients();
      });
      eventBus.$on("filterSelectClients", () => {
        this.filterSelectClients();
      });
      eventBus.$on("addClientSelect", (item) => {
        if(this.deletedId.includes(item.id)) {
          this.deletedId.splice(this.deletedId.indexOf(item.id), 1);
        }
        if(this.clients[this.clients.indexOf(item)] !== undefined) {
          this.clients[this.clients.indexOf(item)]["disabled"] = true;
        }
      });
      eventBus.$on("addOfferClientSelect", (item) => {
        if(this.clients[this.clients.indexOf(item)] !== undefined) {
          this.clients.filter((item) => {
            item.disabled = true;
          });
        }
        eventBus.$emit('disableAddClientButton', true)
      });
      eventBus.$on('saveClientSuccess', () => {
        this.filterSelectClients();
        eventBus.$emit('disableAddClientButton', true)
      })
      eventBus.$on("deleteClientStep", () => {
        eventBus.$emit('disableAddClientButton', false)
      })
    },
  }
</script>